/**
 * Registration status indicator dot — two expanding ripple rings around a static
 * centre dot, coloured via the global `--status-*` CSS variables. A single SVG so
 * the dot + rings share one coordinate system (cx/cy = 50,50) and stay concentric
 * at every zoom level; `overflow-visible` lets the ripple expand past the viewBox.
 *
 * Shared by the home EventCard and the EventHub hero. Size comes from `className`
 * (cqw inside a container card, fixed units elsewhere).
 */
export default function StatusDot({ color, className = 'size-3' }) {
    return (
        <svg
            viewBox="0 0 100 100"
            style={{ color: `var(${color})` }}
            className={`overflow-visible flex-none ${className}`}
            aria-hidden="true"
        >
            {/* ring 1 — expanding ripple (base r shows only under reduced motion) */}
            <circle
                cx="50"
                cy="50"
                r="28.9"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.6"
                className="animate-status-ripple motion-reduce:animate-none motion-reduce:opacity-40"
            />
            {/* ring 2 — fires 300ms later; hidden during its initial delay */}
            <circle
                cx="50"
                cy="50"
                r="28.9"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.6"
                className="opacity-0 animate-status-ripple [animation-delay:300ms] motion-reduce:animate-none"
            />
            {/* static centre dot */}
            <circle cx="50" cy="50" r="14.6" fill="currentColor" />
        </svg>
    )
}
